module.exports = __webpack_public_path__ + "b1de6da9150da877a28311752b66d582.svg";